import { ActionTypes, GlobalActions } from '@src/types/actions'
import { getType } from 'typesafe-actions'
import { resetState } from '../actions'
import { pusherConnected, pusherDisconnected } from './actions'

export interface PusherState {
  cluster?: string
  appKey?: string
  channelName?: string | null
  connected: boolean
}

export const initialState: PusherState = {
  connected: false,
}

export default function pusherReducer(
  state: PusherState = initialState,
  action: ActionTypes | GlobalActions
) {
  switch (action.type) {
    case getType(pusherConnected):
      const { cluster, appKey, channelName } = action.payload
      return {
        ...state,
        cluster,
        appKey,
        channelName,
        connected: true,
      }
    case getType(pusherDisconnected):
      return {
        ...state,
        channelName: null,
        connected: false,
      }
    case getType(resetState): {
      return initialState
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/pusher/reducer.ts